<div class="confirm">
	<label for="slider" class="confirm__text"><ng-content></ng-content></label>
	<div class="confirm__box" [ngClass]="{ lineLeft: line }">
		<label class="switch" for="slider">
			<input type="checkbox" id="slider" [(ngModel)]="isChecked" (change)="sliderChanged($event)" />
			<span class="slider"></span>
		</label>
	</div>
</div>
